<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      align="start"
      class="fill-height ma-0"
    >
      <v-col
        cols="12"
      >
        <span class="subtitle-1">O método de pagamento utilizado foi o BoaCompra Internacional.</span>
      </v-col>
      <v-col
        cols="12"
      >
        <span class="subtitle-1" v-html="infoText"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {TRANSACTION_TYPE} from "../../helpers/transactions/constants"
  import {mapGetters} from "vuex"
  import {GET_POST_PAYMENT_DATA} from "../../store/modules/post-payment"

  export default {
    name: "BoaCompraMainInfo",
    computed: {
      infoText() {
        if (!this.postPaymentData) return ""

        let infoText = ""
        switch (this.postPaymentData["transaction"]["ab_transaction_type"]) {
          case TRANSACTION_TYPE.IMAGE_PROCESSING:
            infoText = "Após a confirmação do prestador de crédito seu processamento começará automaticamente."
            break
          case TRANSACTION_TYPE.SUBSCRIPTION:
          case TRANSACTION_TYPE.SUBSCRIPTION_UPDATE:
            infoText = "Após a confirmação do prestador de crédito sua assinatura estará ativa."
            break
          case TRANSACTION_TYPE.POST_PROCESSING:
            infoText = "Após a confirmação do prestador de crédito a análise agronômica será realizada."
            break
          case TRANSACTION_TYPE.PHYSICAL_PRODUCT:
            break
          default:
            break
        }
        return infoText
      },
      ...mapGetters({
        postPaymentData: GET_POST_PAYMENT_DATA,
      }),
    },
  }
</script>

<style scoped>

</style>
